<template>
    <div class="custom-spinner-one-main-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
      <div class="custom-spinner-one custom-spinner"></div>
    </div>
</template>

<script>

export default({
    data() {
      return {

      }  
    },
})

</script>

<style scoped lang="scss">
.custom-spinner-one-main-container{
    background-color: #9a9b9b4f;
    z-index: 99999;
    .custom-spinner {
      width: 100px;
      height: 100px;
      border-radius: 100%;
      position: relative;
      margin: 0 auto;
    }
    .custom-spinner-one:before,
    .custom-spinner-one:after {
      content: "";
      position: absolute;
      top: -10px;
      left: -10px;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      border: 10px solid transparent;
      border-top-color: var(--color-dark);
    }
    .custom-spinner-one:before {
      z-index: 100;
      animation: spin 1s infinite;
    }
    .custom-spinner-one:after {
      border: 10px solid #ccc;
    }
}
</style>